import Tooltip from 'components/tooltip/tooltip';

export default class WindStateTooltip extends Tooltip {
  renderTooltip() {
    this.tooltip = document.createElement('div');
    this.tooltip.classList.add('tooltip-popup');

    const tooltipBody = document.createElement('div');
    tooltipBody.classList.add('tooltip-popup__body');
    tooltipBody.classList.add('tooltip-popup__body--custom');
    this.tooltip.appendChild(tooltipBody);

    const content = this.el
      .querySelector('.forecast-table-wind-state-tooltip')
      .cloneNode(true);
    content.classList.remove('js-hidden');
    tooltipBody.appendChild(content);

    this.closeButton = document.createElement('div');
    this.closeButton.classList.add('tooltip-popup__close-button');
    this.tooltip.appendChild(this.closeButton);

    return this.tooltip;
  }
}

export function initWindStateTooltips(container = document) {
  container.querySelectorAll('.wind-state-tooltip').forEach(el => {
    const tooltip = new WindStateTooltip(el);
    tooltip.init();
    console.log('WindStateTooltip');
  });
}
